import React from "react";
import { Redirect } from "react-router";
import axios from "axios";
import PropTypes from "prop-types";
import moment from "moment";
import Name from "../ordination/name";
// import PersonalInfo from "../ordination/personal_info";
import Address from "../ordination/address";
import LoginInfo from "../ordination/login_info";
import Beliefs from "../ordination/beliefs";
import MinisterCheckbox from "../fields/minister_checkbox";
import ValidatingForm from "../forms/validating_form";

class FullApplication extends ValidatingForm {
  constructor(props) {
    super(props);

    this.state = {
      minister: this.props.minister,
      serverErrors: [],
      formErrors: {},
      erroredFields: [],
      redirect: false
    };

    this.state.minister.dob = "0001-01-01";
    this.state.minister.gender = "undisclosed";

    document.title = "Ordination Application";

    this.updateFormError = this.updateFormError.bind(this);
    this.submit = this.submit.bind(this);
  }

  today() {
    return moment().format("dddd MMMM Do, YYYY");
  }

  isValid() {
    const formErrors = this.state.formErrors;
    const minister = this.props.minister;

    return (
      this.hasNoFormErrors(formErrors) &&
      this.completedApplication(minister) &&
      this.props.acknowledgements.deliberate_request &&
      this.props.acknowledgements.policy
    );
  }

  hasNoFormErrors(formErrors) {
    if (formErrors.constructor === Object) {
      if (Object.keys(formErrors).length === 0) return true;
      else {
        for (var propertyName in formErrors) {
          if (Object.keys(formErrors[propertyName]).length != 0) return false;
        }
        return true;
      }
    }
    return false;
  }

  completedApplication(minister) {
    let ministerArray = Object.entries(minister);
    for (var i = 0; i < ministerArray.length; i++) {
      if (
        ministerArray[i][0] != "id" &&
        ministerArray[i][0] != "middle_name" &&
        ministerArray[i][1] === ""
      ) {
        return false;
      }
    }
    return true;
  }

  submit(e) {
    e.preventDefault();
    return axios
      .post(
        "/users",
        { user: this.props.minister },
        { headers: { Accept: "application/json" } }
      )
      .then(response => {
        if (this.props.minister.newsletter_opt_in) {
          axios
            .post("/mailchimp/subscribe", {
              email: this.props.minister.email,
              first_name: this.props.minister.first_name,
              last_name: this.props.minister.last_name
            })
            .then(function(response) {
              console.log(response);
            })
            .catch(error => {
              this.handleSubmitErrors(error);
            });
        }
        this.props.updateModel("id", response.data.id);
        this.setState({
          redirect: true
        });
      })
      .catch(error => {
        this.handleSubmitErrors(error);
      });
  }

  updateFormError(property, newErrors) {
    this.setState({
      formErrors: Object.assign({}, this.state.formErrors, {
        [property]: Object.assign({}, this.state.formErrors.property, newErrors)
      })
    });
  }

  render() {
    if (this.state.redirect) {
        return <Redirect push to={{ pathname: "/confirmation" }} />;
    }
    return (
      <div className="ord-application">
        <h1>Ordination Application</h1>
        <p className="subtitle">To become an ordained minister, fill out and submit the form below.</p>
        <div className="ord_application_box">
          <Name
            onChange={this.isValid}
            updateFormError={this.updateFormError}
            updateModel={this.props.updateModel}
            minister={this.props.minister}
          />
          <Address
            onChange={this.isValid}
            updateFormError={this.updateFormError}
            updateModel={this.props.updateModel}
            minister={this.props.minister}
          />
          <LoginInfo
            onChange={this.isValid}
            updateFormError={this.updateFormError}
            updateModel={this.props.updateModel}
            minister={this.props.minister}
          />
          <Beliefs
            updateFormError={this.updateFormError}
            acknowledgements={this.props.acknowledgements}
            updateAcknowledgement={this.props.updateAcknowledgement}
          />
          <div className='ordchecks'>
            <label>
              <MinisterCheckbox
                name="newsletter_opt_in"
                onChange={this.props.updateSubscription}
                checked={this.props.minister.newsletter_opt_in}
              />
              <span className="checkbox_label">
                Subscribe to the AMM Newsletter!
              </span>
            </label>
          </div>
          <div className="input-error">{this.state.errorMessage}</div>
          <button className="cta" disabled={!this.isValid()} onClick={this.submit} >
            ORDAIN ME!
          </button>
          <p className='date'>Ordination Date:<br/>{this.today()}</p>
        </div>
        <div className='ordination_policy'>
          <h2>American Marriage Ministries Ordination Policy</h2>
          <h3>Rights of an AMM Minister</h3>
          <p>
            AMM Ministers are directly authorized to perform marriage. You may
            perform other religious functions in keeping with your faith.
          </p>
          <h3>Duties of the AMM Minister</h3>
          <p>
            As an AMM Minister, you are expected to act with honesty and integrity, and observe all laws and regulations. You are expected to perform your duties conscientiously, investing the time and effort required to create a meaningful wedding ceremony.
          </p>
          <h3>Limitations of the AMM Ordination</h3>
          <p>
            Your ordination will only be valid if the information you submit is
            factually accurate and submitted in good faith.
          </p>
          <br/><hr/><br/>
          <h2>AMM TENETS</h2>
          <ol>
            <li>All people, regardless of race, gender, or sexual orientation, have the right to marry.</li>
            <li>It is the right of every couple to choose who will solemnize their marriage.</li>
            <li>All people have the right to solemnize marriage.</li>
          </ol>
        </div>
      </div>
    );
  }
}

FullApplication.propTypes = {
  updateModel: PropTypes.func.isRequired,
  updateSubscription: PropTypes.func.isRequired,
  newsletter_opt_in: PropTypes.bool.isRequired,
  acknowledgements: PropTypes.object.isRequired,
  minister: PropTypes.object.isRequired,
  savedPartialMinister: PropTypes.func.isRequired,
  updateAcknowledgement: PropTypes.func.isRequired
};

export default FullApplication;
